import { createContext , useReducer , useContext, useEffect } from "react";

const AuthContext = createContext()

export const authReducer = (state,action) => {
    switch(action.type){
        case 'LOGIN':
            return { user: action.payload }
        case 'LOGOUT':
            return { user: null }
        default:
            return state
    }
}

export const AuthContextProvider = ({children}) => {

    const [state,dispatch] = useReducer(authReducer,{
        user: null
    })
    console.log('Authentication state: ',state)

    useEffect(() => {
        // console.log("inside auth useeffect")
        const user = JSON.parse(localStorage.getItem('user'))
        if(user){
            dispatch({type: 'LOGIN',payload: user})
        }
    },[])

    return(
        <AuthContext.Provider value={{...state,dispatch}}>
        {children}
        </AuthContext.Provider>
    )
}

export const AuthState = () => {
    return useContext(AuthContext)
}